import { Link } from 'wouter';
import { ROUTES } from '../../routes/Routes';
import { AppConstant } from '../../constant/AppConstant';
import logo from "../../assets/icons/app_logo_name.png";
import '../../assets/css/components/Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-gradient-line"></div>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col footer-col-large">
            <img alt='logo' src={logo} />
            {/* <h3 className="footer-brand-logo">Logicraft Intotech</h3> */}
            <p className="footer-desc">
              Delivering cutting-edge web apps, mobile apps, and IT consulting to build digital futures.
            </p>
            {/* <div className="footer-newsletter">
              <input type="email" placeholder="Subscribe to newsletter" />
              <button>Join</button>
            </div> */}
            <div className="footer-social">
              <a href={AppConstant.facebook_link} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="footer-social-link">
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a href={AppConstant.instagram_link} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="footer-social-link">
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {Object.values(ROUTES).map((route) => (
                <li key={route.path}>
                  <Link href={route.path} className="footer-link-item">{route.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link href={ROUTES.SERVICE.path} className="footer-link-item">Web Development</Link></li>
              <li><Link href={ROUTES.SERVICE.path} className="footer-link-item">Mobile Apps</Link></li>
              <li><Link href={ROUTES.SERVICE.path} className="footer-link-item">Cloud Solutions</Link></li>
              <li><Link href={ROUTES.SERVICE.path} className="footer-link-item">IT Consulting</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div>
                  <span>Email</span>
                  <a href={`mailto:${AppConstant.company_email}`}>{AppConstant.company_email}</a>
                </div>
              </li>
              <li className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div>
                  <span>Phone</span>
                  <a href={`tel:${AppConstant.company_mobile}`}>{AppConstant.company_mobile}</a>
                </div>
              </li>
              <li className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div>
                  <span>Location</span>
                  <a href="#">{AppConstant.company_address}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © {new Date().getFullYear()} Logicraft Infotech. All rights reserved.</p>
          <p>Made with passion by Logicraft Infotech</p>
        </div>
      </div>
    </footer>
  );
}